import * as React from 'react';
import type { SVGProps } from 'react';
const SvgContacts = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={17} fill="none" {...props}>
    <path fill="#616061" d="M8 4a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0M3 8.5a3 3 0 0 0-3 3v3h8v-6zM13 8.5h-3v6h6v-3a3 3 0 0 0-3-3M12 6.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
  </svg>
);
export default SvgContacts;
